import { RestClient } from "./restClient";
import RestResponse from "@/models/client/RestResponse";
import RequestMethod from "@/models/client/RequestMethod";

/** Which per-tenant recipient list a subscription toggles (API enum names). */
export type NotificationSettingsType = "Workspace" | "PiiOverride";

/** The current user's own subscription flags (GET me/notifications/settings). */
export type MyNotificationSettings = {
  workspaceSubscriber: boolean;
  piiOverrideSubscriber: boolean;
};

export type NotificationSettingsServiceType = {
  getMine: () => RestResponse<MyNotificationSettings>;
  subscribe: (settingsType: NotificationSettingsType) => RestResponse<unknown>;
  unsubscribe: (
    settingsType: NotificationSettingsType
  ) => RestResponse<unknown>;
};

const notificationSettingsServices = (
  client: RestClient,
  path: string
): NotificationSettingsServiceType => ({
  getMine: async () => {
    return await client.fetch<MyNotificationSettings>(RequestMethod.GET, path);
  },
  subscribe: async (settingsType: NotificationSettingsType) => {
    return await client.fetch<unknown>(RequestMethod.PUT, path, {
      settingsType,
    });
  },
  unsubscribe: async (settingsType: NotificationSettingsType) => {
    return await client.fetch<unknown>(RequestMethod.DELETE, path, {
      settingsType,
    });
  },
});

export default notificationSettingsServices;
